export enum eTemplatesTable {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
  PAUSED = 'PAUSED',
  APPEALED = 'APPEALED',
  DISABLED = 'DISABLED',
  DELETED = 'DELETED',
}

export enum eNotificationStatus {
  READ = 'READ',
  UNREAD = 'UNREAD',
}

export enum eTemplateQuality {
  HIGH = 'HIGH',
  MEDIUM = 'MEDIUM',
  LOW = 'LOW',
  PENDING = 'PENDING',
}
